import type { KpiCard } from "@/pages/admin/dashboard/dashboardData";

interface KpiGridProps {
  cards: KpiCard[];
}

const BUBBLE: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function KpiGrid({ cards }: KpiGridProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 md:gap-5">
      {cards.map((card) => {
        const up = card.delta >= 0;
        return (
          <div
            key={card.label}
            className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5"
          >
            <div className="flex items-start justify-between gap-3">
              <span
                className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full ${BUBBLE[card.tone]}`}
              >
                <i className={`${card.icon} text-xl`}></i>
              </span>
              <span
                className={`inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-1 rounded-full whitespace-nowrap ${
                  up
                    ? "bg-secondary-100 text-secondary-800"
                    : "bg-accent-100 text-accent-900"
                }`}
              >
                <i className={up ? "ri-arrow-up-line" : "ri-arrow-down-line"}></i>
                {Math.abs(card.delta)}%
              </span>
            </div>
            <p className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mt-4 truncate">
              {card.value}
            </p>
            <div className="flex items-center gap-2 mt-1">
              <p className="text-xs md:text-sm text-foreground-600">{card.label}</p>
              <span
                className={`text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded ${
                  card.live ? "bg-primary-100 text-primary-700" : "bg-background-200 text-foreground-500"
                }`}
              >
                {card.live ? "Live" : "Sample"}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}